module.exports = __webpack_public_path__ + "media/images/home/main/temas-ebfd9daf273e8cc2061013ffaa070ddb.png";